import { render } from "./downloadSet.vue?vue&type=template&id=a88a472a&scoped=true"
import script from "./downloadSet.vue?vue&type=script&lang=js"
export * from "./downloadSet.vue?vue&type=script&lang=js"

import "./downloadSet.vue?vue&type=style&index=0&id=a88a472a&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88a472a"]])

export default __exports__